import service from "../utils/axios";

// 获取客户端信息
const getClientInfo = (data) => {
  return service.get("/oauth/client", { params: data });
};

// 确认Oauth授权
const confirmOAuth = (data) => {
  return service.post("/oauth/authorize/confirm", data);
};

export {
  getClientInfo,
  confirmOAuth
}